/* FitWin — колесо фортуны. Без внешних зависимостей. */
(function () {
  'use strict';

  var LS_DONE = 'fw_wheel_done';
  var LS_CLOSED = 'fw_wheel_closed_at';
  var LS_FORCE = 'fw_wheel_force';

  var root = document.getElementById('fw-wheel');
  var cfgEl = document.getElementById('fw-wheel-config');
  if (!root || !cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var modal = root.querySelector('.fw-modal');
  var rotor = root.querySelector('[data-fw-rotor]');
  var form = root.querySelector('[data-fw-form]');
  var emailInput = root.querySelector('[data-fw-email]');
  var errorEl = root.querySelector('[data-fw-error]');
  var spinBtn = root.querySelector('[data-fw-spin]');
  var stepForm = root.querySelector('[data-fw-step="form"]');
  var stepWin = root.querySelector('[data-fw-step="win"]');
  var prizeEl = root.querySelector('[data-fw-prize]');
  var codeEl = root.querySelector('[data-fw-code]');
  var copyBtn = root.querySelector('[data-fw-copy]');
  var subForm = document.getElementById('fw-subscribe-form');

  if (subForm) subForm.setAttribute('target', 'fw-sub-frame');

  var state = { open: false, spinning: false, won: false, opened: false };
  var lastFocused = null;
  var openTimer = null;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function eligible() {
    if (lsGet(LS_DONE)) return false;
    var t = parseInt(lsGet(LS_CLOSED) || '0', 10);
    if (t && Date.now() - t < (cfg.cooldownDays || 7) * 864e5) return false;
    return true;
  }

  /* ---------- показ ---------- */

  function open() {
    if (state.opened) return;
    state.opened = true;
    state.open = true;
    clearTimeout(openTimer);
    document.removeEventListener('mouseout', onExitIntent);
    lastFocused = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('fw-lock');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-open'); });
    });
    /* Страховка от замороженного транзишена (троттлинг вкладки/окна):
       через 700 мс попап принудительно полностью непрозрачен. */
    setTimeout(function () { root.classList.add('is-settled'); }, 700);
    setTimeout(function () { emailInput && emailInput.focus(); }, 380);
    document.addEventListener('keydown', onDocKeydown);
  }

  function close() {
    if (!state.open) return;
    state.open = false;
    root.classList.remove('is-open');
    root.classList.remove('is-settled');
    document.documentElement.classList.remove('fw-lock');
    document.removeEventListener('keydown', onDocKeydown);
    setTimeout(function () { root.hidden = true; }, 320);
    if (state.won || state.spinning) {
      lsSet(LS_DONE, '1');
    } else {
      lsSet(LS_CLOSED, String(Date.now()));
    }
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function onExitIntent(e) {
    if (!e.relatedTarget && e.clientY <= 0) open();
  }

  /* Клавиши внутри попапа: Tab — фокус-трап, Esc — закрыть, остальное — печать.
     stopPropagation, чтобы глобальные хоткеи темы/приложений не съедали ввод. */
  function onRootKeydown(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') { e.stopPropagation(); return; }
    var items = modal.querySelectorAll('button, input, [href], [tabindex]:not([tabindex="-1"])');
    var focusable = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].offsetParent !== null && !items[i].disabled) focusable.push(items[i]);
    }
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* Резерв на случай, если фокус ушёл из попапа: Esc всё равно закрывает. */
  function onDocKeydown(e) {
    if (e.key === 'Escape') close();
  }

  /* ---------- подписка (штатная форма Shopify) ---------- */

  function subscribe(email) {
    if (!subForm) return;
    var f = subForm.querySelector('input[name="contact[email]"]');
    if (f) f.value = email;
    /* Магазин требует hCaptcha-токен на POST /contact. Официальный механизм:
       Shopify.captcha.protect(form, cb) навешивает на форму невидимую hCaptcha,
       cb зовётся, когда форма ГОТОВА. Тогда requestSubmit() перехватывается,
       hCaptcha кладёт токен в форму и вызывает нативный submit — он уходит
       в скрытый iframe (target), так что страница никуда не уводится. */
    var cap = window.Shopify && window.Shopify.captcha;
    if (cap && typeof cap.protect === 'function' && subForm.requestSubmit) {
      try {
        cap.protect(subForm, function () {
          if (window.console && console.debug) console.debug('[fw-wheel] subscribe: protected, submitting');
          subForm.requestSubmit();
        });
        return;
      } catch (e) {}
    }
    /* Фолбэк для магазинов без captcha-защиты форм */
    var fd = new FormData(subForm);
    fetch(subForm.getAttribute('action'), {
      method: 'POST',
      body: new URLSearchParams(fd),
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    }).then(function (r) {
      if (window.console && console.debug) console.debug('[fw-wheel] subscribe', r.status, r.url);
    }).catch(function () {});
  }

  /* ---------- вращение ---------- */

  function spin() {
    var k = Math.floor(Math.random() * cfg.sectors.length);
    var jitter = Math.random() * 36 - 18; /* внутри сектора, не по центру */
    var target = 5 * 360 + (360 - 60 * k) + jitter;
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      rotor.removeEventListener('transitionend', finish);
      showWin(k);
    }
    rotor.addEventListener('transitionend', finish);
    setTimeout(finish, 5800); /* страховка, если transitionend не пришёл */
    requestAnimationFrame(function () {
      rotor.style.transition = 'transform 5.2s cubic-bezier(0.1, 0.6, 0.08, 1)';
      rotor.style.transform = 'rotate(' + target.toFixed(1) + 'deg)';
    });
  }

  function showWin(k) {
    var sector = cfg.sectors[k];
    state.won = true;
    prizeEl.textContent = sector.prize;
    codeEl.textContent = sector.code;
    stepForm.hidden = true;
    stepWin.hidden = false;
    lsSet(LS_DONE, '1');
    /* код в корзину через штатный маршрут скидок */
    var base = (cfg.root || '/').replace(/\/$/, '');
    fetch(base + '/discount/' + encodeURIComponent(sector.code), { credentials: 'same-origin' })
      .then(function (r) { if (window.console && console.debug) console.debug('[fw-wheel] discount', r.status); })
      .catch(function () {});
    confetti();
    setTimeout(function () { copyBtn && copyBtn.focus(); }, 120);
  }

  /* ---------- конфетти ---------- */

  function confetti() {
    var box = document.createElement('div');
    box.className = 'fw-confetti';
    var colors = ['#ff8400', '#eccf62', '#24221d', '#ffffff', '#f6f1e8'];
    for (var i = 0; i < 54; i++) {
      var s = document.createElement('span');
      var size = 6 + Math.random() * 6;
      s.style.left = Math.random() * 100 + '%';
      s.style.width = size + 'px';
      s.style.height = size * (0.6 + Math.random() * 0.8) + 'px';
      s.style.background = colors[i % colors.length];
      s.style.animationDelay = (Math.random() * 0.5) + 's';
      s.style.setProperty('--fw-dx', (Math.random() * 160 - 80).toFixed(0) + 'px');
      s.style.setProperty('--fw-rot', (360 + Math.random() * 540).toFixed(0) + 'deg');
      box.appendChild(s);
    }
    modal.appendChild(box);
    setTimeout(function () { box.remove(); }, 3600);
  }

  /* ---------- события ---------- */

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (state.spinning) return;
    var email = (emailInput.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      errorEl.hidden = false;
      emailInput.classList.add('is-invalid');
      emailInput.focus();
      return;
    }
    errorEl.hidden = true;
    emailInput.classList.remove('is-invalid');
    state.spinning = true;
    spinBtn.disabled = true;
    emailInput.disabled = true;
    lsSet(LS_DONE, '1'); /* подписался — больше не показываем */
    subscribe(email);
    spin();
  });

  emailInput.addEventListener('input', function () {
    errorEl.hidden = true;
    emailInput.classList.remove('is-invalid');
  });

  copyBtn.addEventListener('click', function () {
    var code = codeEl.textContent;
    function okUi() {
      copyBtn.textContent = (cfg.strings && cfg.strings.copied) || 'Copied!';
      setTimeout(function () {
        copyBtn.textContent = (cfg.strings && cfg.strings.copy) || 'Copy';
      }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(okUi).catch(function () { legacyCopy(code); okUi(); });
    } else {
      legacyCopy(code);
      okUi();
    }
  });

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    ta.remove();
  }

  var closers = root.querySelectorAll('[data-fw-close]');
  for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);
  root.addEventListener('keydown', onRootKeydown);

  /* ---------- запуск ---------- */

  window.FitwinWheel = {
    open: function () { state.opened = false; open(); },
    reset: function () {
      try {
        localStorage.removeItem(LS_DONE);
        localStorage.removeItem(LS_CLOSED);
      } catch (e) {}
    }
  };

  if (lsGet(LS_FORCE)) {
    open();
    return;
  }
  if (!eligible()) return;
  openTimer = setTimeout(open, cfg.delayMs || 18000);
  document.addEventListener('mouseout', onExitIntent);
})();
